// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1Ikas","error":"Textarea_error__2DLkQ","readonly":"Textarea_readonly__2zqr-","disabled":"Textarea_disabled__28eCt"};